<template>
    <div>
        <b-row>
            <b-col cols="12" class="mt-3">
                <h2 class="text-center">{{$t('user.profile_section')}}</h2>
            </b-col>
            <b-col cols="12" class="mt-2 border-bottom mb-3">
            </b-col>
            <b-col sm="12" lg="6" cols="12" class="mt-2">
                <label for="name">{{$t('user.name')}} <span style="color: red">*</span></label>
                <b-form-input v-model="profile.name" :placeholder="$t('user.name_placeholder')"
                              id="name"></b-form-input>
                <b-form-invalid-feedback v-if="errors.name" :state="errors.name" :force-show="true" tag="span">{{
                    errors.name }}
                </b-form-invalid-feedback>
            </b-col>
            <b-col sm="12" lg="6" cols="12" class="mt-2">
                <label for="email">{{$t('user.email')}} <span style="color: red">*</span></label>
                <b-form-input v-model="profile.email" :placeholder="$t('user.email_placeholder')" id="email"
                              type="email"></b-form-input>
                <b-form-invalid-feedback v-if="errors.email" :state="errors.email" :force-show="true" tag="span">{{
                    errors.email }}
                </b-form-invalid-feedback>
            </b-col>
            <b-col sm="12" lg="4" cols="12" class="mt-3" v-if="profile.has_password">
                <label for="current_password">{{$t('user.current_password')}}</label>
                <b-form-input v-model="profile.current_password" :placeholder="$t('user.password_placeholder')"
                              id="current_password" type="password"></b-form-input>
                <b-form-invalid-feedback v-if="errors.current_password" :state="errors.current_password"
                                         :force-show="true"
                                         tag="span">{{ errors.current_password }}
                </b-form-invalid-feedback>
            </b-col>
            <b-col sm="12" :lg="profile.has_password ? 4: 6" cols="12" class="mt-3">
                <label for="new_password">{{$t('user.new_password')}}</label>
                <b-form-input v-model="profile.new_password" :placeholder="$t('user.password_placeholder')"
                              id="new_password" type="password"  minlength="8"
                              aria-describedby="feedback-error"
                              required autocomplete="new-password"></b-form-input>
                <password v-model="profile.new_password" :strength-meter-only="true"/>
                <b-form-invalid-feedback v-if="errors.new_password" :state="errors.new_password" :force-show="true"
                                         tag="span">{{ errors.new_password }}
                </b-form-invalid-feedback>
            </b-col>
            <b-col sm="12" :lg="profile.has_password ? 4: 6" cols="12" class="mt-3">
                <label for="new_password_confirmation">{{$t('user.new_password_confirmation')}}</label>
                <b-form-input v-model="profile.new_password_confirmation" :placeholder="$t('user.password_placeholder')"
                              id="new_password_confirmation" type="password" autocomplete="new-password"></b-form-input>
                <b-form-invalid-feedback v-if="errors.new_password_confirmation"
                                         :state="errors.new_password_confirmation"
                                         :force-show="true" tag="span">{{ errors.new_password_confirmation }}
                </b-form-invalid-feedback>
            </b-col>
            <b-col sm="12" lg="6" cols="12" class="mt-3 align-items-end d-grid">
                <b-button variant="outline-primary" @click="updateProfile">{{$t('user.update_profile')}}</b-button>
            </b-col>
            <b-col cols="12" class="mt-4 border-bottom mb-3">
            </b-col>
            <b-col cols="12" class="mt-3">
                <h2 class="text-center">{{$t('user.payment_methods')}}</h2>
            </b-col>

        </b-row>

        <payment-methods></payment-methods>
        <b-row>
            <b-col cols="12" class="mt-4 border-bottom mb-3">
            </b-col>
        </b-row>
        <b-row class="mb-5">
            <b-col sm="12" lg="6" cols="12" class="align-items-end d-grid">
                <b-button variant="outline-danger" @click="logout">{{$t('general.logout')}}</b-button>
            </b-col>
            <b-col sm="12" lg="6" cols="12" class="align-items-end d-grid mt-3 justify-end">
                <div class="text-right">v.{{$root.version.version}} ({{$root.version.build}})</div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {errors} from "../mixins/errors";
    import {notifications} from '../mixins/notifications';
    import PaymentMethods from "./partials/payment-methods";
    import Password from 'vue-password-strength-meter';

    export default {
        name: 'account',
        components: {PaymentMethods, Password},
        mixins: [errors, notifications],
        beforeRouteEnter(to, f, next) {
            window._store.dispatch('user/loadProfile').then(() => {
                next();
            }).catch(e => {
                return next({
                    name: 'tests_active'
                });
            });
        },
        data() {
            let profile = _.cloneDeep(this.$store.getters['user/profile']) || {};
            profile.current_password = null;
            profile.new_password = null;
            profile.new_password_confirmation = null;

            return {
                lang: this.$i18n.locale,
                profile: profile,
                stripe: null
            }
        },
        methods: {
            changeLanguage(language) {
                this.$i18n.locale = language;
                this.$router.push({
                    params: {
                        lang: language
                    }
                });
                this.$cookie.set('lang', language, {
                    expires: '1M'
                });

                return this.$root.lang = language;
            },
            updateProfile() {
                this.errors = {};
                this.$store.dispatch('user/updateProfile', this.profile).then((profile) => {
                    this.profile = profile;
                    this.profile.current_password = null;
                    this.profile.new_password = null;
                    this.profile.new_password_confirmation = null;
                    this.pushNotification(this.$t('user.profile_updated'), 'success');
                }).catch(e => {
                    this.handleResponseErrors(e);
                });
            },
            logout() {
                this.$store.dispatch('auth/logout');
            },
        }
    }
</script>

<style scoped>

</style>
